import { GridColDef } from "@mui/x-data-grid";

type Props = {
};

export const GenerateEntradaProdutosMultiColumns = (_: Props): GridColDef[] => {
  return [
    {
      field: "NomeProdutoServico",
      filterable: false,
      headerName: "Produto",
      flex: 1,
      minWidth: 50,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Unidade",
      filterable: false,
      headerName: "Unidade",
      width: 120,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      width: 120,
      minWidth: 120,
      headerName: "Quantidade",
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center p-1">
            {
              value !== null &&
              new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value)
            }
          </div>
        );
      },
    },
    {
      field: "ValorUnitario",
      filterable: false,
      width: 120,
      minWidth: 120,
      headerName: "Valor Unitário",
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center p-1">
            {
              value !== null &&
              new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }).format(value)
            }
          </div>
        );
      },
    },
    {
      field: "ValorTotal",
      filterable: false,
      width: 150,
      minWidth: 150,
      headerName: "Valor Unitário",
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center p-1">
            {
              value !== null &&
              new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              }).format(value)
            }
          </div>
        );
      },
    },
  ];
};
